import { render, staticRenderFns } from "./OnboardingReport.vue?vue&type=template&id=be1ae906&"
import script from "./OnboardingReport.vue?vue&type=script&lang=js&"
export * from "./OnboardingReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports